const SLICES = 16;
const OFFSET = 50;
const COLOUR_R = 14;
const COLOUR_G = -4;
const COLOUR_B = 2;
export function glitchFadeOut(filter, object) {
    const timeline = gsap.timeline();
    timeline.add(() => {
        object.filters = [filter];
    }, 0);
    const sliceData = { slices: 0 };
    timeline.fromTo(sliceData, {
        slices: 0
    }, {
        slices: SLICES,
        duration: 2,
        onUpdate: () => {
            filter.slices = Math.round(sliceData.slices);
        },
    }, 0);
    timeline.fromTo(filter, {
        offset: 0
    }, {
        offset: OFFSET,
        duration: 2,
    }, 0);
    timeline.add(createTweenForGlitchFilterColour(filter, "red", 0, COLOUR_R), 0);
    timeline.add(createTweenForGlitchFilterColour(filter, "green", 0, COLOUR_G), 0);
    timeline.add(createTweenForGlitchFilterColour(filter, "blue", 0, COLOUR_B), 0);
    timeline.fromTo(object, { alpha: 1 }, { alpha: 0, duration: 1, ease: "expo.out" }, 1);
    timeline.add(() => {
        object.filters = undefined;
    });
    return timeline;
}
export function glitchFadeIn(filter, object) {
    const timeline = gsap.timeline();
    timeline.add(() => {
        object.filters = [filter];
    }, 0);
    const sliceData = { slices: filter.slices };
    timeline.fromTo(sliceData, {
        slices: SLICES
    }, {
        slices: 0,
        duration: 2,
        onUpdate: () => {
            filter.slices = Math.round(sliceData.slices);
        },
    }, 0);
    timeline.fromTo(filter, {
        offset: OFFSET
    }, {
        offset: 0,
        duration: 2,
    }, 0);
    timeline.add(createTweenForGlitchFilterColour(filter, "red", COLOUR_R, 0), 0);
    timeline.add(createTweenForGlitchFilterColour(filter, "green", COLOUR_G, 0), 0);
    timeline.add(createTweenForGlitchFilterColour(filter, "blue", COLOUR_B, 0), 0);
    timeline.fromTo(object, { alpha: 0 }, { alpha: 1, duration: 2, ease: "expo.out" }, 0);
    timeline.add(() => {
        object.filters = undefined;
    });
    return timeline;
}
function createTweenForGlitchFilterColour(filter, colourKey, fromValue, toValue) {
    const colour = { x: 0, y: 0 };
    return gsap.fromTo(colour, {
        x: fromValue
    }, {
        duration: 2,
        x: toValue,
        onUpdate: () => {
            filter[colourKey][0] = colour.x;
        }
    });
}
//# sourceMappingURL=GlitchFilterTween.js.map